import { useState, useEffect, useRef, useCallback } from 'react';

const useInterval = (callback, delay) => {
  const savedCallback = useRef();
  const [intervalId, setIntervalId] = useState();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick () {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      setIntervalId(id);
      return () => clearInterval(id);
    }
  }, [delay]);

  return intervalId;
};

const useProgress = ({ delay }) => {
  const [progress, setProgress] = useState(0);
  const intervalId = useRef();

  intervalId.current = useInterval(() => setProgress(p => p < 100 ? p + 1 : p), delay);

  const endProgress = useCallback(() => {
    setProgress(100);
    clearInterval(intervalId.current);
  }, []);

  return { progress, endProgress };
};

export default useProgress;
